import React from 'react';
import styled, { withTheme } from 'styled-components';
import { TopNavBar, Screen, BottomTabBar, FavMarketList } from '../components';

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  padding: 2px 0;
  background: ${props => props.theme.fav.bg};
`;

const FavMarkets = ({ theme, watchList, exchange, markets, selectMarket }) => (
  <Screen theme={theme} title="Favorites">
    <TopNavBar title="Coinmend" left="ios-grid-outline" right="ios-add" rightSize="32px" />
    <Content>
      <FavMarketList watchList={watchList} exchange={exchange} markets={markets} selectMarket={selectMarket} />
    </Content>
    <BottomTabBar selected="favorites" />
  </Screen>
);

export default withTheme(FavMarkets);



// WEBPACK FOOTER //
// ./src/containers/FavMarkets.js